<section class="section white-100" *ngIf="transactionalFxData">
  <div class="section-container-inside">
    <div class="extensive-coverage-container grey-900">
      <div>
        <div class="product-blog-subheading mar-b-16 white">
          {{ transactionalFxData?.tag }}
        </div>
        <div class="extensive-coverage-heading white">
          {{ transactionalFxData?.title }}
        </div>
        <p class="product-blog-description white">
          {{ transactionalFxData?.description }}
        </p>
      </div>
      <div class="international-business-blog">
        <img src="{{ transactionalFxData?.image }}" alt="" />
      </div>
    </div>
  </div>
</section>
